import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withStyles,
} from "@material-ui/core";

export const StyledDialog = withStyles((theme) => ({
  paper: {
    padding: 20,
    borderRadius: 0,
  },
}))(Dialog);

export const StyledDialogTitle = withStyles((theme) => ({
  root: { color: "#212121", fontSize: 18, fontWeight: "bolder", padding: 10 },
}))(DialogTitle);

export const StyledDialogContentText = withStyles((theme) => ({
  root: { color: "#212121", fontSize: 18, fontWeight: "bolder", padding: 10 },
}))(DialogContentText);

export const StyledDialogTransparent = withStyles((theme) => ({
  paper: {
    padding: 20,
    borderRadius: 0,
    backgroundColor: "rgba(255,255,255, 0)"
  },
}))(Dialog);
